import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DesignPartnerFeedbackService {
  private apiUrl = `${environment.BACKEND_URL}/auth/design-partner/feedback`;

  constructor(private http: HttpClient) {}

  getFeedback(): Observable<any> {
    return this.http.get(this.apiUrl);
  }

  submitFeedback(note: string): Observable<any> {
    return this.http.post(this.apiUrl, { note });
  }
}
